import React from 'react';

function Trouble(props){
    const style={
        backgroundColor: props.bg
    };
    return (
        <div className={"troubles"} style={style}>
            {props.troubleInfo}
            {props.machineInfo}
            {props.workInfo}
            {props.troubleDesc}
        </div>
    )
}


export default Trouble;